import {
  getAngieAdjustmentsForQualifyingInfrastructureCompanies,
  getAngieDownwardAdjustments,
  getAngieGroupMismatchAdjustments,
  getAngieInterestAllowanceAlternativeCalculation,
  getAngieInterestAllowanceNonConsolidatedInvestment,
  getAngieOther,
  getAngieUpwardAdjustments,
} from "../../../pages/group-data/utils/angieUtils";
import {
  getPageTooltips,
  getSelectedPeriod,
} from "../../../services/GroupContext";
import {
  addGroupDataSubheaderCells,
  extractKeyValuePairsFromExcel,
  getWorksheetFromFile,
} from "./DataImportUtils";
import {
  addGroupDataWorksheet,
  downloadGroupDataImportTemplate,
  getGroupDataInitialSheetBuilder,
  validateImportedGroupData,
} from "./groupDataImportUtils";

const getTableRows = (rows, isImportTemplate = true) => {
  const angie = getSelectedPeriod()?.angie;
  const result = [];
  Object.entries(rows).forEach(([key, config]) => {
    addGroupDataSubheaderCells({
      list: result,
      data: angie,
      key,
      config,
      isImportTemplate,
    });
  });
  return result;
};

const generateSheetBuilder = (isImportTemplate) => {
  const tooltips = getPageTooltips("angieModal");
  const angieUpwardAdjustments = getAngieUpwardAdjustments(tooltips);
  const angieDownwardAdjustments = getAngieDownwardAdjustments(tooltips);
  const angieGroupMismatchAdjustments =
    getAngieGroupMismatchAdjustments(tooltips);
  const angieInterestAllowanceAlternativeCalculation =
    getAngieInterestAllowanceAlternativeCalculation(tooltips);
  const angieInterestAllowanceNonConsolidatedInvestment =
    getAngieInterestAllowanceNonConsolidatedInvestment(tooltips);
  const angieAdjustmentsForQualifyingInfrastructureCompanies =
    getAngieAdjustmentsForQualifyingInfrastructureCompanies(tooltips);
  const angieOther = getAngieOther(tooltips);

  return [
    ...getGroupDataInitialSheetBuilder(),
    {
      label: `NGIE`,
      type: "header",
      value: getSelectedPeriod()?.local_curr_net_group_interest_expense ?? 0,
      validation: "number",
    },
    { label: "" },
    { label: "Upward Adjustments", type: "header" },
    ...getTableRows(angieUpwardAdjustments, isImportTemplate),
    { label: "Downward Adjustments", type: "header" },
    ...getTableRows(angieDownwardAdjustments, isImportTemplate),
    { label: "Group Mismatch Adjustments (SI 2017/1224)", type: "header" },
    ...getTableRows(angieGroupMismatchAdjustments, isImportTemplate),
    {
      label: "Interest Allowance (Alternative Calculation) Election",
      type: "header",
    },
    ...getTableRows(
      angieInterestAllowanceAlternativeCalculation,
      isImportTemplate,
    ),
    {
      label: "Interest Allowance (Non-ConsolidatedInvestment) Election",
      type: "header",
    },
    ...getTableRows(
      angieInterestAllowanceNonConsolidatedInvestment,
      isImportTemplate,
    ),
    {
      label: "Adjustments for Qualifying Infrastructure Companies",
      type: "header",
    },
    ...getTableRows(
      angieAdjustmentsForQualifyingInfrastructureCompanies,
      isImportTemplate,
    ),
    { label: "Other", type: "header" },
    ...getTableRows(angieOther, isImportTemplate),
  ];
};

const worksheetName = "ANGIE";

export async function handleAngieDownloadTemplate({
  workbook,
  isImportTemplate = true,
  isClientFacing = true,
}) {
  const params = {
    sheetBuilder: generateSheetBuilder(isImportTemplate),
    documentName: "ANGIE Import Template",
    worksheetName,
    isClientFacing,
  };
  if (workbook) {
    addGroupDataWorksheet({ ...params, workbook, isImportTemplate });
  } else {
    await downloadGroupDataImportTemplate(params);
  }
}

export async function handleAngieImport({
  file,
  setErrors,
  setWarnings,
  setNewData,
}) {
  try {
    const worksheet = await getWorksheetFromFile(file, worksheetName);
    const sheetBuilder = generateSheetBuilder();
    const { results: angie, warnings } = await extractKeyValuePairsFromExcel(
      worksheet,
      sheetBuilder,
    );

    // validate angie keys
    validateImportedGroupData({ importedData: angie, sheetBuilder, setErrors });

    if (warnings?.length > 0) {
      setNewData(angie);
      setWarnings(warnings);
      return;
    }

    return angie;
  } catch (error) {
    const errorObject = JSON.parse(error.message);
    console.error("Error importing ANGIE:", errorObject ?? error);
    if (errorObject.missingWorkSheetErrorMessage) {
      setErrors([
        {
          title:
            errorObject.missingWorkSheetErrorMessage ?? "Error Importing ANGIE",
        },
      ]);
    }
  }
}
